import moment from 'moment'
/* Format timestamp "DD/MM/YYYY HH:mm" */
export default (timestamp) => {
    return moment(timestamp).format('DD/MM/YYYY HH:mm');
}


// WEBPACK FOOTER //
// ./src/filters/formatTimeStamp.js